import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimRadioGroup } from '../fields';

export const Box01_InsuranceType: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">1. INSURANCE TYPE</Typography>
      <Controller
        name="insuranceType"
        control={control}
        render={({ field, fieldState }) => (
          <ClaimRadioGroup
            field={field}
            fieldState={fieldState}
            options={[
              { value: 'medicare', label: 'Medicare' },
              { value: 'medicaid', label: 'Medicaid' },
              { value: 'tricare', label: 'TRICARE' },
              { value: 'champva', label: 'CHAMPVA' },
              { value: 'groupHealth', label: 'Group Health Plan' },
              { value: 'feca', label: 'FECA Black Lung' },
              { value: 'other', label: 'Other' },
            ]}
            row
            sx={{ gap: 1, flexWrap: 'wrap' }}
          />
        )}
      />
    </>
  );
};
